import { Component, inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ProductionService, RouterService, SpeedyCookieService } from '@speedy/core';

import { SpeedyButtonComponent } from '../speedy-button/speedy-button.component';
import { BlockComponent } from '../block/block.component';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  standalone: true,
  imports: [BlockComponent, SpeedyButtonComponent, MatIcon],
})
export class CookiesComponent implements OnInit {
  private readonly cookieService = inject(SpeedyCookieService);
  private readonly productionService = inject(ProductionService);
  private readonly routerService = inject(RouterService);

  cookieAgreedFlag = this.cookieService.getCookieAgreeValue();
  cookieVisible = false;

  ngOnInit() {
    if (!this.cookieAgreedFlag && this.productionService.isBrowserMode()) {
      this.cookieVisible = true;
    }
  }

  agreeToUseCookies() {
    this.cookieService.agreeToUseCookies();
    this.cookieAgreedFlag = true;
  }

  closeCookieBar() {
    this.cookieVisible = false;
    this.cookieService.disagreeToUseCookies();
  }

  isBrowserMode() {
    return this.productionService.isBrowserMode();
  }
}
